An array of identifiers for the `HiringOrganization`s that have the position.

Scheme requirements:

- The `seekAnz` scheme requires exactly one element that matches the position opening's `PostingRequester.id`.
